import { Button, Card, Form, Grid, Icon, Input, Menu, Pagination, Segment, Select } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import PageContainer from '../../common/PageContainer';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import { bindActionCreators } from 'redux';
import AddListingModal from './AddListingModal';
import { Formik } from 'formik';
import ListingSearchPageItem from './ListingSearchItem';
import ListingSearchPageTable from './ListingSearchTable';

const ListingSearchPage = ({
  listings,
  getFirms,
  getListings,
  loading,
  firms,
  paginate,
  setQuery,
  pages,
  activePage,
  view,
  setView,
}) => {
  useEffect(() => {
    getFirms();
    getListings();
    // getReps();
    // preloadShowcaseData();
  }, []);

  const getPage = () => (
    <PageContainer>
      <Menu borderless>
        <Menu.Item header>
          <Icon name="star outline" />
          Listings
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item header fitted>
            <Button.Group compact>
              <Button icon="image" active={view === 'grid'} onClick={() => setView('grid')} />
              <Button icon="table" active={view === 'table'} onClick={() => setView('table')} />
            </Button.Group>
          </Menu.Item>
          <Menu.Item header>
            <AddListingModal />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Grid reversed="mobile">
        <Grid.Column computer="13" table="10" mobile="16">
          {view === 'grid' && <ListingSearchPageItem listings={listings} />}
          {view === 'table' && <ListingSearchPageTable listings={listings} />}

          <Segment basic style={{ display: 'grid', justifyContent: 'center' }}>
            <Pagination
              onPageChange={(e, { activePage }) => paginate(activePage)}
              activePage={activePage || 1}
              totalPages={pages}
            />
          </Segment>
        </Grid.Column>
        <Grid.Column computer="3" tablet="6" mobile="16">
          <Formik
            enableReinitialize
            initialValues={{ showcaseFirmId: '', description1: '', description2: '', address: '', type: '' }}
            onSubmit={values => {
              setQuery({ ...values, page: 1 });
              getListings();
            }}
          >
            {formik => (
              <Form size="small" onSubmit={formik.handleSubmit}>
                <Card fluid>
                  <Card.Content>
                    <Form.Field>
                      <label>Firm</label>
                      <Select
                        options={firms}
                        value={formik.values.showcaseFirmId}
                        search
                        fluid
                        size="small"
                        loading={loading}
                        onChange={(e, { value }) => formik.setFieldValue('showcaseFirmId', value)}
                        placeholder="Search firms"
                        name="showcaseFirmId"
                        id="showcaseFirmId"
                        label="Firm"
                        clearable
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Type</label>
                      <Select
                        options={['Product', 'Property', 'Property w/o Realtor'].map(k => ({
                          key: k,
                          value: k,
                          text: k,
                        }))}
                        value={formik.values.type}
                        search
                        fluid
                        size="small"
                        loading={loading}
                        onChange={(e, { value }) => formik.setFieldValue('type', value)}
                        placeholder="Search types"
                        name="type"
                        id="type"
                        label="Type"
                        clearable
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Description 1</label>
                      <Input
                        fluid
                        size="small"
                        value={formik.values.description1}
                        onChange={formik.handleChange}
                        name="description1"
                        id="description1"
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Description 2</label>
                      <Input
                        fluid
                        size="small"
                        value={formik.values.description2}
                        onChange={formik.handleChange}
                        name="description2"
                        id="description2"
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Line 1</label>
                      <Input
                        fluid
                        size="small"
                        value={formik.values.line1}
                        onChange={formik.handleChange}
                        name="line1"
                        id="line1"
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Line 2</label>
                      <Input
                        fluid
                        size="small"
                        value={formik.values.line2}
                        onChange={formik.handleChange}
                        name="line2"
                        id="line2"
                      />
                    </Form.Field>

                    <Form.Field>
                      <label>Address</label>
                      <Input
                        fluid
                        size="small"
                        value={formik.values.address}
                        onChange={formik.handleChange}
                        name="address"
                        id="address"
                      />
                    </Form.Field>

                    <br />

                    <Button fluid type="submit" positive>
                      Search
                    </Button>

                    <br />

                    <Button
                      type="button"
                      fluid
                      content="Clear"
                      onClick={() => {
                        formik.resetForm();
                        formik.handleSubmit();
                      }}
                    />
                  </Card.Content>
                </Card>
              </Form>
            )}
          </Formik>
        </Grid.Column>
      </Grid>
    </PageContainer>
  );

  return <>{listings && getPage()}</>;
};

const mapStateToProps = state => ({
  listings: selectors.getListings(state),
  loading: selectors.users.loading(state),
  firms: selectors.firms.firmLookupOptions(state),
  activePage: selectors.listings.activePage(state),
  pages: selectors.listings.pages(state),
  view: selectors.listings.view(state),
});

const mapDispatchToProps = dispatch => ({
  getListings: bindActionCreators(actions.listing.getListings, dispatch),
  getFirms: bindActionCreators(actions.firm.getFirmsForLookup, dispatch),
  setCurrentListing: bindActionCreators(actions.listing.setCurrentListing, dispatch),
  navigate: bindActionCreators(actions.user.navigate, dispatch),
  paginate: bindActionCreators(actions.listing.paginate, dispatch),
  setActivePage: bindActionCreators(actions.listing.setActivePage, dispatch),
  setQuery: bindActionCreators(actions.listing.setQuery, dispatch),
  setView: bindActionCreators(actions.listing.setView, dispatch),
  preloadShowcaseData: bindActionCreators(actions.showcase.preloadShowcaseData, dispatch),
  getReps: bindActionCreators(actions.rep.getReps, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListingSearchPage);
